import { render, staticRenderFns } from "./PointGmoneyComplete.vue?vue&type=template&id=677acc96"
import script from "./PointGmoneyComplete.vue?vue&type=script&lang=js"
export * from "./PointGmoneyComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports